import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ProductIdentifier } from '@platform-frontend/marketplace';
import { RedirectAnchorInterceptorService } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { FlowState } from './flow.state';

@Injectable({
  providedIn: 'root'
})
export class ProductBasedRedirectAnchorInterceptorService {
  constructor(private redirectAnchorInterceptorService: RedirectAnchorInterceptorService, private store: Store) {}

  intercept(request: HttpRequest<any>, next: HttpHandler, appContext: 'product' | 'standalone'): Observable<HttpEvent<any>> {
    const anchorValues: string[] = [this.store.selectSnapshot(FlowState.flowType)];
    const productIdentifier: ProductIdentifier | null = this.store.selectSnapshot(FlowState.productIdentifier);
    const vendorId: string | null = this.store.selectSnapshot(FlowState.vendorId);
    if (productIdentifier) {
      anchorValues.push(JSON.stringify(productIdentifier));
    } else if (vendorId) {
      anchorValues.push(vendorId);
    }
    return this.redirectAnchorInterceptorService.intercept(request, next, appContext, anchorValues);
  }
}
